'use client';

import {EVENTS} from '../events';
import {logTmrEvent} from './logTmrEvent';
import {emitYmEvent} from './ymEvent';

export const logBreadcrumbsClick = (title: string) => {
  emitYmEvent('appPage_breadCrumbs_click');

  logTmrEvent(EVENTS.breadcrumbsClick, {
    button_text: title,
  });
};
